// Geeks Comfort — global interactions
(function () {
  // scroll reveal
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  // animated counters
  var cio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, end = parseFloat(el.dataset.count) || 0, t0 = performance.now();
      function tick(t) {
        var p = Math.min((t - t0) / 1400, 1);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      cio.unobserve(el);
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });

  // hero 3D tilt
  var stage = document.querySelector('.chair-stage');
  var hero = document.querySelector('.hero');
  if (stage && hero && matchMedia('(pointer:fine)').matches) {
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      stage.style.transform = 'rotateY(' + x * 7 + 'deg) rotateX(' + (-y * 6) + 'deg)';
    });
    hero.addEventListener('mouseleave', function () { stage.style.transform = ''; });
  }

  // feature card spotlight
  document.querySelectorAll('.feat').forEach(function (f) {
    f.addEventListener('mousemove', function (e) {
      var r = f.getBoundingClientRect();
      f.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      f.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  });

  // mobile menu
  var toggle = document.querySelector('.menu-toggle');
  var links = document.querySelector('.nav-links');
  if (toggle && links) {
    toggle.addEventListener('click', function () { links.classList.toggle('open'); });
  }

  // ajax quick add
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-quick-add');
    btn.textContent = 'Adding…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error();
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      btn.textContent = 'Added ✓';
      var count = document.querySelector('.cart-count');
      if (count) count.textContent = cart.item_count;
      setTimeout(function () { btn.textContent = 'Add to cart'; }, 1800);
    }).catch(function () {
      btn.textContent = 'Try again';
    });
  });

  // product gallery thumbs
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.thumbs img');
    if (!t) return;
    var main = document.querySelector('.main-img img');
    if (main) main.src = t.dataset.full || t.src;
    document.querySelectorAll('.thumbs img').forEach(function (i) { i.classList.remove('active'); });
    t.classList.add('active');
  });
})();
